import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Avatar } from "../../components"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"

/* Icons */
import { CloseIcon, TrophyIcon, ChipIcon, JackpotIcon, SafeIcon, CardsIcon, MultiplierIcon, HashIcon, TableIcon, StudioIcon, OperatorIcon, CalendarIcon, RateIcon, VipIcon } from "./BonusIcons"

/* Utils */
import { getGame, getName, getAvatar, getCurrency, isWon, toNumber, getWinUSD, getJackpotPart, getCashPart, formatDate, formatAgo } from "./BonusUtils"


/* Widget Bonus Detail */
class Detail extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            item: null,
        }
    }

    /* Open Action — the row already holds everything, no second request is needed */
    open = (item) => {
        this.setState({ visible: true, item })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, item: null })
    }

    /* Draw One Field */
    _info = (icon, title, value, note = null) => {

        return (
            <div className="bns--info-item">

                {icon}

                <div className="bns--info-text">
                    <div className="bns--info-title">{title}</div>
                    <div className="bns--info-value">{value}</div>
                    {note && <div className="bns--info-note">{note}</div>}
                </div>

            </div>
        )
    }

    /* Draw The Money Of The Round */
    _amount = (item) => {

        /* Fields */
        const currency = getCurrency(item.currency)
        const won = isWon(item)

        return (
            <div className={`bns--amount ${won ? "win" : "lose"}`}>

                <div className="bns--amount-main">
                    <div className="bns--amount-title">{t("bns.bet")}</div>
                    <div className="bns--amount-value">{utils.convertor(item.dollarBonus, "USD", 1)}</div>
                    {String(currency) !== "USD" && <div className="bns--amount-note">{utils.convertor(item.bonus, currency, 1)}</div>}
                </div>

                <div className="bns--amount-main right">
                    <div className="bns--amount-title">{t("bns.win")}</div>
                    <div className={`bns--amount-value ${won ? "green" : "empty"}`}>{won ? utils.convertor(getWinUSD(item), "USD", 1) : "—"}</div>
                    {won && String(currency) !== "USD" && <div className="bns--amount-note">{utils.convertor(item.win, currency, 1)}</div>}
                </div>

            </div>
        )
    }

    /* Draw The Pools Of The Operator — where the bet went and what the win took away */
    _pools = (item) => {

        /* Fields */
        const ratio = toNumber(item.jackpotRatio)
        const jackpot = toNumber(item.jackpot)
        const cash = toNumber(item.score)
        const win = isWon(item) ? getWinUSD(item) : 0

        return (
            <div className="bns--pools">

                {/* Jackpot */}
                <div className="bns--pool jackpot">

                    <div className="bns--pool-head">
                        <JackpotIcon />
                        JACKPOT
                        <span className="bns--pool-ratio">{ratio}</span>
                    </div>

                    <div className="bns--pool-row">
                        <span>{t("bns.poolBefore")}</span>
                        <b>{utils.convertor(jackpot, "USD", 1)}</b>
                    </div>

                    <div className="bns--pool-row plus">
                        <span>{t("bns.poolShare")}</span>
                        <b>+ {utils.convertor(getJackpotPart(item), "USD", 1)}</b>
                    </div>

                    <div className="bns--pool-row total">
                        <span>{t("bns.poolAfter")}</span>
                        <b>{utils.convertor(jackpot + getJackpotPart(item), "USD", 1)}</b>
                    </div>

                </div>

                {/* Cash */}
                <div className="bns--pool cash">

                    <div className="bns--pool-head">
                        <SafeIcon />
                        {t("bns.cash")}
                        <span className="bns--pool-ratio">{Number((1 - ratio).toFixed(4))}</span>
                    </div>

                    <div className="bns--pool-row">
                        <span>{t("bns.poolBefore")}</span>
                        <b>{utils.convertor(cash, "USD", 1)}</b>
                    </div>

                    <div className="bns--pool-row plus">
                        <span>{t("bns.poolShare")}</span>
                        <b>+ {utils.convertor(getCashPart(item), "USD", 1)}</b>
                    </div>

                    {win > 0 &&
                        <div className="bns--pool-row minus">
                            <span>{t("bns.win")}</span>
                            <b>− {utils.convertor(win, "USD", 1)}</b>
                        </div>
                    }

                    <div className="bns--pool-row total">
                        <span>{t("bns.poolAfter")}</span>
                        <b>{utils.convertor(cash + getCashPart(item) - win, "USD", 1)}</b>
                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, item } = this.state

        /* Check Item */
        if (!item) {

            return (
                <Modal
                    isOpen={visible}
                    onRequestClose={() => this.close()}
                    className="bns--modal"
                    overlayClassName="bns--overlay"
                    closeTimeoutMS={200}
                />
            )
        }

        /* Fields */
        const won = isWon(item)
        const currency = getCurrency(item.currency)
        const rate = toNumber(item.currencyRate)

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="bns--modal"
                overlayClassName="bns--overlay"
                closeTimeoutMS={200}
            >

                <div className="bns--modal-header">

                    <div className={`bns--modal-icon ${won ? "win" : ""}`}>
                        {won ? <TrophyIcon size={18} /> : <ChipIcon size={18} />}
                    </div>

                    <div className="bns--modal-head-text">
                        <h2>{won ? t("bns.detailWin") : t("bns.detailTitle")}</h2>
                        <p>{utils.checkValue(item.uid, "—")}</p>
                    </div>

                    <div onClick={() => this.close()} className="bns--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="bns--modal-body">

                    {/* Player */}
                    <div className="bns--profile">

                        <Avatar uri={getAvatar(item)} size={46} />

                        <div className="bns--profile-text">

                            <div className="bns--profile-name">
                                <span className="bns--player-value">{getName(item)}</span>
                                {parseInt(item.isTester) === 1 && <span className="bns--tag tester">{t("bns.tester")}</span>}
                                {parseInt(item.isVip) === 1 &&
                                    <span className="bns--tag vip">
                                        <VipIcon size={10} />
                                        VIP
                                    </span>
                                }
                            </div>

                            <div className="bns--profile-code">{item.player}</div>

                        </div>

                        <div className="bns--operator" title={utils.checkValue(item.operator, "")}>
                            <OperatorIcon size={11} />
                            <span>{utils.checkValue(item.operator, "—")}</span>
                        </div>

                    </div>

                    {/* Money */}
                    {this._amount(item)}

                    {/* Result */}
                    <div className="bns--section">

                        <div className="bns--section-head">
                            <div className="bns--section-title">
                                <TrophyIcon />
                                {t("bns.result")}
                            </div>
                        </div>

                        <div className="bns--info">
                            {this._info(<CardsIcon />, t("bns.combination"), won ? utils.checkValue(item.combination, "—") : "—")}
                            {this._info(<MultiplierIcon />, t("bns.multiplier"), won && item.multiplier ? `${item.multiplier} : 1` : "—")}
                        </div>

                    </div>

                    {/* Round */}
                    <div className="bns--section">

                        <div className="bns--section-head">
                            <div className="bns--section-title">
                                <HashIcon />
                                {t("bns.round")}
                            </div>
                        </div>

                        <div className="bns--info">
                            {this._info(<HashIcon />, t("bns.gameNumber"), utils.checkValue(item.gameNumber, "—"))}
                            {this._info(<TableIcon />, t("bns.game"), getGame(item), utils.checkValue(item.table, null))}
                            {this._info(<StudioIcon />, t("bns.studio"), utils.checkValue(item.studio, "—"))}
                            {this._info(<RateIcon />, t("bns.rate"), currency === "USD" || rate <= 0 ? "—" : `1 ${currency} = ${Number(rate).toFixed(6)} USD`)}
                            {this._info(<CalendarIcon />, t("bns.date"), formatDate(item.createdAt), formatAgo(item.createdAt))}
                        </div>

                    </div>

                    {/* Pools */}
                    <div className="bns--section">

                        <div className="bns--section-head">
                            <div className="bns--section-title">
                                <JackpotIcon />
                                {t("bns.pools")}
                            </div>
                        </div>

                        {this._pools(item)}

                    </div>

                </div>

                <div className="bns--modal-footer">
                    <div onClick={() => this.close()} className="bns--button primary">{t("common.close")}</div>
                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Detail)
